jQuery(document).ready(function ($) {
    $('.wp-caption-text:contains("Click to download")').each(function () {
        var href = $(this).siblings('a').attr('href');
        var filename = href.substring(href.lastIndexOf('/')+1);
        $(this).html('<a href="' + href.replace('cdn.', 'www.') + '" download="' + filename + '">Click to download</a>');
    });
});